import SectionCounter1 from "../../../sections/home/index/section-counter1";
import { useEffect } from "react";
import { loadScript, publicUrlFor } from "../../../../globals/constants";
import { NavLink } from "react-router-dom";
import {
  FaTachometerAlt,
  FaCode,
  FaMobileAlt,
  FaShieldAlt,
} from "react-icons/fa";
import Seo from "../../common/Seo";

function WebDevDetailsPage() {
  useEffect(() => {
    loadScript("js/custom.js");
  }, []);

  return (
    <>
      <Seo
        title="Website Development Company In Pune"
        description="DArchTech is a trusted website development company delivering fast, responsive, and SEO-optimized websites that drive traffic, leads & business growth."
      />

      {/* SERVICE DETAIL SECTION START */}
      <div className="section-full p-40 sx-ser-detail-outer sx-bg-white">
        {/* Banner Section */}
        <div
          className="sx-bnr-1-wrap overlay-overlay"
          style={{
            backgroundImage: `url(${publicUrlFor(
              "images/services/service-detail-web.jpg"
            )})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "85vh",
            display: "flex",
            alignItems: "center",
            backfaceVisibility: "hidden",
            backgroundBlendMode: "multiply",
            backgroundColor: "rgba(0, 0, 0, 0.19)",
          }}
        >
          <div className="sx-bg-overlay opacity-0 sx-bg-primary" />

          <div className="container">
            <div className="sx-bnr-1-content text-center">
              {/* H1 */}
              <h1
                style={{ fontSize: "7vw" }}
                className="sx-bnr-1-large-title fw-bolder text-light mb-3"
              >
                Website Development Services in Pune
              </h1>

              {/* H2 */}
              <h2 className="sx-bnr-1-info fs-4 text-light mb-4">
                Build Powerful, Scalable And High-Conversion Websites That Grow
                Your Business
              </h2>

              {/* CTA */}
              <div className="sx-bnr-readmore mt-4">
                <NavLink
                  to="/contact-us"
                  className="site-button sx-btn-primary icon"
                >
                  Request A Call
                </NavLink>
              </div>
            </div>
          </div>
        </div>

        {/* Content Container */}
        <div className="container m-t50">
          <div className="section-content">
            <div className="sx-our-service-detail">
              {/* Section Header */}
              <div className="section-head2">
                <div className="sx-head-l-title">
                  <h2 className="sx-title2 text-center">
                    Transform Your Online Presence with Custom Website
                    Development
                  </h2>
                </div>
              </div>

              {/* Service Description */}
              <div className="sx-our-service-info m-b10 text-center px-5">
                <p>
                  At <strong>DArch Tech</strong>, we are proud to be recognized
                  as one of the best website development companies in Pune. We
                  design and develop professional, SEO-friendly,
                  mobile-responsive websites that not only look stunning but
                  also convert visitors into customers. Whether you're launching
                  a new business, growing an ecommerce brand, or modernizing
                  your digital footprint, we build websites that perform.
                </p>
                <div className="sx-head-s-title h3 mt-5">
                  Why Choose Our Website Development Services?
                </div>

                {/* Feature Grid – 2x2 Layout */}
                <div className="row sx-about-icon-bx1-column p-t50 p-b20">
                  {/* Feature 1 */}
                  <div className="col-lg-6 col-md-6 col-sm-12 m-b30">
                    <div className="sx-icon-bx-2 rounded p-4 h-100">
                      <div className="sx-media mb-3">
                        <FaTachometerAlt size={38} />
                      </div>
                      <div className="sx-icon-bx-info">
                        <h5 className="sx-icon-bx-title">
                          High-Performance, SEO-Ready Websites
                        </h5>
                        <p className="sx-icon-bx">
                          We build websites optimized for speed, search engines,
                          and user experience — helping you rank better and
                          convert more.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Feature 2 */}
                  <div className="col-lg-6 col-md-6 col-sm-12 m-b30">
                    <div className="sx-icon-bx-2 rounded p-4 h-100">
                      <div className="sx-media mb-3">
                        <FaCode size={38} />
                      </div>
                      <div className="sx-icon-bx-info">
                        <h5 className="sx-icon-bx-title">
                          Custom Development, Tailored to Your Business Needs
                        </h5>
                        <p className="sx-icon-bx">
                          From static brochure sites to dynamic web applications
                          and ecommerce solutions, we tailor every project
                          specifically to your goals and target audience.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Feature 3 */}
                  <div className="col-lg-6 col-md-6 col-sm-12 m-b30">
                    <div className="sx-icon-bx-2 rounded p-4 h-100">
                      <div className="sx-media mb-3">
                        <FaMobileAlt size={38} />
                      </div>
                      <div className="sx-icon-bx-info">
                        <h5 className="sx-icon-bx-title">
                          Responsive Across All Devices
                        </h5>
                        <p className="sx-icon-bx">
                          Your website will look and function perfectly on
                          desktops, tablets, and mobile phones — ensuring a
                          seamless experience for every visitor.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Feature 4 */}
                  <div className="col-lg-6 col-md-6 col-sm-12 m-b30">
                    <div className="sx-icon-bx-2 rounded p-4 h-100">
                      <div className="sx-media mb-3">
                        <FaShieldAlt size={38} />
                      </div>
                      <div className="sx-icon-bx-info">
                        <h5 className="sx-icon-bx-title">
                          Secure, Scalable & Future-Ready
                        </h5>
                        <p className="sx-icon-bx">
                          We implement best-in-class security features and
                          scalable architecture so your website grows with your
                          business.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Counters */}
              <SectionCounter1 />
              {/* PROCESS SECTION START */}
              <div className="section-full p-t10 p-b10">
                <div className="container">
                  {/* Section Heading */}
                  <div className="section-head2 text-center">
                    <h2 style={{ color: "#116A7A", fontWeight: "700" }}>
                      Our Website Development Process
                    </h2>
                    <p style={{ color: "#333333", marginTop: "10px" }}>
                      We follow a proven, transparent development process to
                      deliver quality results.
                    </p>
                  </div>

                  <div className="row m-t40">
                    {/* Card 1 */}
                    <div className="col-lg-4 col-md-6 m-b30">
                      <div
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #d6edf2",
                          borderRadius: "8px",
                          padding: "25px",
                          height: "100%",
                        }}
                      >
                        <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                          Discovery & Strategy
                        </h4>
                        <p style={{ color: "#333333", marginTop: "10px" }}>
                          We dive deep into your brand, target audience, and
                          business goals to craft a powerful development
                          strategy.
                        </p>
                      </div>
                    </div>

                    {/* Card 2 */}
                    <div className="col-lg-4 col-md-6 m-b30">
                      <div
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #d6edf2",
                          borderRadius: "8px",
                          padding: "25px",
                          height: "100%",
                        }}
                      >
                        <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                          Design & UX Blueprint
                        </h4>
                        <p style={{ color: "#333333", marginTop: "10px" }}>
                          We map intuitive navigation and visual design that
                          enhances engagement and supports conversions.
                        </p>
                      </div>
                    </div>

                    {/* Card 3 */}
                    <div className="col-lg-4 col-md-6 m-b30">
                      <div
                        style={{
                          backgroundColor: "#ffffff",
                          border: "1px solid #d6edf2",
                          borderRadius: "8px",
                          padding: "25px",
                          height: "100%",
                        }}
                      >
                        <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                          Development & Testing
                        </h4>
                        <p style={{ color: "#333333", marginTop: "10px" }}>
                          Using the latest technologies, we build secure,
                          robust, and responsive websites that stand the test of
                          time.
                        </p>
                      </div>
                    </div>

                    {/* Centered Last Two Cards */}
                    <div className="col-12 d-flex justify-content-center">
                      <div className="row justify-content-center w-100">
                        {/* Card 4 */}
                        <div className="col-lg-4 col-md-6 m-b30">
                          <div
                            style={{
                              backgroundColor: "#ffffff",
                              border: "1px solid #d6edf2",
                              borderRadius: "8px",
                              padding: "25px",
                              height: "100%",
                            }}
                          >
                            <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                              Launch & Optimization
                            </h4>
                            <p style={{ color: "#333333", marginTop: "10px" }}>
                              After rigorous testing, we launch your site and
                              implement analytics and tools for ongoing
                              performance tracking.
                            </p>
                          </div>
                        </div>

                        {/* Card 5 */}
                        <div className="col-lg-4 col-md-6 m-b30">
                          <div
                            style={{
                              backgroundColor: "#ffffff",
                              border: "1px solid #d6edf2",
                              borderRadius: "8px",
                              padding: "25px",
                              height: "100%",
                            }}
                          >
                            <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                              Support & Growth
                            </h4>
                            <p style={{ color: "#333333", marginTop: "10px" }}>
                              Need updates, new features, or scaling support?
                              We've got you covered.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* PROCESS SECTION END */}

              {/* TYPES OF WEBSITES SECTION START */}
              <div
                className="section-full p-b40"
                style={{ backgroundColor: "#ffffff" }}
              >
                <div className="container">
                  {/* Section Heading */}
                  <div className="section-head2 text-center">
                    <h2 style={{ color: "#116A7A", fontWeight: "700" }}>
                      Types of Websites We Build
                    </h2>
                  </div>

                  <div className="row m-t40">
                    {[
                      "Corporate & Business Websites",
                      "E-Commerce & Online Stores",
                      "Landing Pages for Lead Generation",
                      "CMS & Blog Platforms",
                      "Dynamic Web Applications",
                      "Portfolio & Personal Branding Sites",
                    ].map((type, index) => (
                      <div className="col-lg-4 col-md-6 m-b20" key={index}>
                        <div
                          style={{
                            backgroundColor: "#f0f7f9",
                            borderLeft: "4px solid #116A7A",
                            padding: "18px 22px",
                            borderRadius: "6px",
                            color: "#116A7A",
                            fontWeight: "600",
                          }}
                        >
                          {type}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* TYPES OF WEBSITES SECTION END */}

              {/* FAQ SECTION START */}
              <div
                className="section-full p-t40 p-b80"
                style={{ backgroundColor: "#f5f8fa" }}
              >
                <div className="container">
                  {/* Section Heading */}
                  <div className="section-head2 text-center">
                    <div className="sx-head-l-title">
                      <h2 className="sx-title2" style={{ color: "#116A7A" }}>
                        Website Development FAQs
                      </h2>
                    </div>
                  </div>

                  {/* Accordion */}
                  <div className="accordion sx-accordion" id="websiteDevFaq">
                    {/* FAQ 1 */}
                    <div className="accordion-item">
                      <h3 className="accordion-header" id="faqOne">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                          style={{
                            backgroundColor: "#e0f0f3",
                            color: "#116A7A",
                            fontWeight: "600",
                          }}
                        >
                          How long does it take to build a website?
                        </button>
                      </h3>
                      <div
                        id="collapseOne"
                        className="accordion-collapse collapse show"
                        aria-labelledby="faqOne"
                        data-bs-parent="#websiteDevFaq"
                      >
                        <div
                          className="accordion-body"
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#333333",
                          }}
                        >
                          Most standard business websites take
                          <strong> 4-8 weeks</strong> depending on design
                          complexity, features, content readiness, and approval
                          timelines.
                        </div>
                      </div>
                    </div>

                    {/* FAQ 2 */}
                    <div className="accordion-item">
                      <h3 className="accordion-header" id="faqTwo">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="true"
                          aria-controls="collapseTwo"
                          style={{
                            backgroundColor: "#e0f0f3",
                            color: "#116A7A",
                            fontWeight: "600",
                          }}
                        >
                          Do you offer maintenance after website launch?
                        </button>
                      </h3>
                      <div
                        id="collapseTwo"
                        className="accordion-collapse collapse show"
                        aria-labelledby="faqTwo"
                        data-bs-parent="#websiteDevFaq"
                      >
                        <div
                          className="accordion-body"
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#333333",
                          }}
                        >
                          Yes. We provide
                          <strong>
                            {" "}
                            ongoing maintenance, updates, security monitoring,
                            and performance optimization
                          </strong>{" "}
                          to keep your website secure and fast.
                        </div>
                      </div>
                    </div>

                    {/* FAQ 3 */}
                    <div className="accordion-item">
                      <h3 className="accordion-header" id="faqThree">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="true"
                          aria-controls="collapseThree"
                          style={{
                            backgroundColor: "#e0f0f3",
                            color: "#116A7A",
                            fontWeight: "600",
                          }}
                        >
                          Why should I choose DArch Tech for website development
                          in Pune?
                        </button>
                      </h3>
                      <div
                        id="collapseThree"
                        className="accordion-collapse collapse show"
                        aria-labelledby="faqThree"
                        data-bs-parent="#websiteDevFaq"
                      >
                        <div
                          className="accordion-body"
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#333333",
                          }}
                        >
                          <strong>DArch Tech</strong> delivers
                          <strong>
                            {" "}
                            custom, SEO-optimized, and scalable websites
                          </strong>
                          aligned with business goals through a transparent and
                          performance-driven development process.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* FAQ SECTION END */}
            </div>
          </div>
        </div>
      </div>
      {/* SERVICE DETAIL SECTION END */}

      {/* Supporting Sections */}
      {/* <SectionVideo2 /> */}
      {/* <SectionWhyChooseUs4 /> */}
      {/* <SectionClients2 /> */}
    </>
  );
}

export default WebDevDetailsPage;
